import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  data() {
    return {
      defaultLangList: [
        this.getLanguagesByCode('cs', true),
        this.getLanguagesByCode('sk'),
        this.getLanguagesByCode('en'),
        this.getLanguagesByCode('hu'),
        this.getLanguagesByCode('uk'),
        this.getLanguagesByCode('ru')
      ]
    };
  },
  computed: {
    language: {
      get() {
        return this.$store.state.profile.accountSettings.language;
      },
      set(value) {
        this.$store.dispatch('profile/accountSettings/setLanguage', value);
      }
    },

    partnerMutations() {
      return Array.isArray(this.partnerData?.mutations) ? this.partnerData.mutations : [];
    },

    languageList() {
      if (!this.$auth.user?.benefit?.active) {
        return this.getNonBenefitLanguageList();
      }

      const mutations = this.partnerMutations;
      const list = mutations.length
        ? mutations.map(val => this.getLanguagesByCode(val.language, true))
        : [...this.defaultLangList];

      this.ensureValidLanguage(list);
      return list;
    }
  },
  methods: {
    getLanguagesByCode(code, addDefault = false) {
      switch (code) {
        case 'cs':
          return {
            id: 'cs',
            countryCode: 'CZ',
            value: `Čeština${addDefault ? ' (výchozí)' : ''} `
          };
        case 'en':
          return {
            id: 'en',
            countryCode: 'GB',
            countryCodePrint: 'EN',
            value: 'English'
          };
        case 'sk':
          return {
            id: 'sk',
            countryCode: 'SK',
            value: 'Slovenčina'
          };
        case 'uk':
          return {
            id: 'uk',
            countryCode: 'UA',
            value: this.$t('languageSwitcher.uk')
          };
        case 'ru':
          return {
            id: 'ru',
            countryCode: 'RU',
            value: this.$t('languageSwitcher.ru')
          };
        case 'hu':
          return {
            id: 'hu',
            countryCode: 'HU',
            value: 'Magyar nyelv'
          };
      }
    },

    ensureValidLanguage(list) {
      if (!list.find(val => val.id === this.language)) {
        this.language = list[0]?.id;
      }
    },

    finalizeLanguageList(languageCodes) {
      let list = languageCodes.map(this.getLanguagesByCode);

      if (this.isCz) {
        list = list.filter(lang => lang.id !== 'hu' && lang.id !== 'sk');
      }

      this.ensureValidLanguage(list);
      return list;
    },
    getNonBenefitLanguageList() {
      if (this.isSk) {
        return this.finalizeLanguageList(['sk', 'en']);
      }

      if (this.isHu) {
        return this.finalizeLanguageList(['hu', 'en']);
      }

      return this.finalizeLanguageList(this.defaultLangList.map(lang => lang.id));
    }
  }
};
